import { render, staticRenderFns } from "./BuddhismAdmin.vue?vue&type=template&id=168a76f6&scoped=true"
import script from "./BuddhismAdmin.vue?vue&type=script&lang=js"
export * from "./BuddhismAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a76f6",
  null
  
)

export default component.exports